export default "__VITE_ASSET__a27e44d9__"